var intlTelInput = require('intl-tel-input');
var GoogleAddressField = require("../../../../scripts/classes/GoogleAddressField");

/**
The individual object representing a single loss location.
This would be expanded upon to include multiple input elements
**/

var InsCarrier = function(carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    this.$el = $('<div class="ins-carrier column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="ins-carrier-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    this.$el.find('.ins-carrier-text').text(carrier);

    this.carrier = carrier;
    this.contactName = contactName;
    this.contactTitle = contactTitle;
    this.email = email;
    this.phone = phone;
    this.claimNum = claimNum;
    this.policyNum = policyNum;
    this.marketPerc = marketPerc;
    this.address = address;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.country = country;
    this.id = -1;

};

// adding the elements to the dom
InsCarrier.prototype.addToDOM = function(){

    $("#ins-carriers-wrap").append(this.$el);

};

// removing the elements from the dom
InsCarrier.prototype.removeFromDOM = function(){

    this.$el.remove();

};

// update the carrier object
InsCarrier.prototype.update = function(carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country){

    var editStr = 'Edit';
    if (window.Language == "spanish")
    {
        editStr = 'Editar';
    }

    var $updatedEl = $('<div class="ins-carrier column small-10 medium-9 large-7"><div class="form-item"><div class="remove-btn"></div><span class="ins-carrier-text"></span><div class="edit-btn">' + editStr + '</div></div></div>');
    $updatedEl.find('.ins-carrier-text').text(carrier);

    // replace the element in the dom
    this.$el.replaceWith($updatedEl);

    // point this object to the updated element
    this.$el = $updatedEl;

    // update this objects variables
    this.carrier = carrier;
    this.contactName = contactName;
    this.contactTitle = contactTitle;
    this.email = email;
    this.phone = phone;
    this.claimNum = claimNum;
    this.policyNum = policyNum;
    this.marketPerc = marketPerc;
    this.address = address;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.country = country;

};

// this updates the form fields associated with this carrier
// so that the values will submit properly to sprout
/*
InsCarrier.prototype.updateFormFields = function(insCarrierId){
    var insCarrierFieldId = insCarrierId + 1; // form fields are 1 indexed


    $('#ins-car-carrier-' + insCarrierFieldId).val(this.carrier);
    $('#ins-car-name-' + insCarrierFieldId).val(this.contactName);
    $('#ins-car-title-' + insCarrierFieldId).val(this.contactTitle);
    $('#ins-car-email-' + insCarrierFieldId).val(this.email);
    $('#ins-car-phone-' + insCarrierFieldId).val(this.phone);
    $('#ins-car-claim-num-' + insCarrierFieldId).val(this.claimNum);
    $('#ins-car-market-' + insCarrierFieldId).val(this.marketPerc);
    $('#ins-car-addr-' + insCarrierFieldId).val(this.address);
    $('#ins-car-city-' + insCarrierFieldId).val(this.city);
    $('#ins-car-state-' + insCarrierFieldId).val(this.state);
    $('#ins-car-zip-' + insCarrierFieldId).val(this.zip);
    $('#ins-car-country-' + insCarrierFieldId).val(this.country);


};
*/

// updating the id of the carrier, based on the total number of active carriers
// inside the DOM
InsCarrier.prototype.updateId = function(index){
    this.$el.attr("data-ins-carrier-id", index);
    this.id = index;
};

// getter functions
InsCarrier.prototype.getCarrier = function(){
    return this.carrier;
};

InsCarrier.prototype.getContactName = function(){
    return this.contactName;
};

InsCarrier.prototype.getContactTitle = function(){
    return this.contactTitle;
};

InsCarrier.prototype.getEmail = function(){
    return this.email;
};

InsCarrier.prototype.getPhone = function(){
    return this.phone;
};

InsCarrier.prototype.getClaimNum = function(){
    return this.claimNum;
};

InsCarrier.prototype.getPolicyNum = function(){
    return this.policyNum;
};

InsCarrier.prototype.getMarketPerc = function(){
    return this.marketPerc;
};

InsCarrier.prototype.getAddress = function(){
    return this.address;
};

InsCarrier.prototype.getCity = function(){
    return this.city;
};

InsCarrier.prototype.getState = function(){
    return this.state;
};

InsCarrier.prototype.getZip = function(){
    return this.zip;
};

InsCarrier.prototype.getCountry = function(){
    return this.country;
};

InsCarrier.prototype.getId = function(){
    return this.id;
};



/**
A controller object that handles the macro-level interactions
for Carriers field itself. This is what show/hides the modal
and creates individual InsCarrier objects, which get added/removed
from the DOM
**/
var InsCarrierController = function(){

    var self = this;

    // a property to hold all our active loss locations
    this.insCarriers = [];

    // set the modal for use later
    this.$modal = $('#ins-carrier-modal');

    // variable to keep track of if we're editing or not when the modal is open
    this.isEditingId = -1;

    // get our modal fields
    this.$fieldCarrier    = $('#ins-car-carrier');
    this.$fieldName       = $('#ins-car-name');
    this.$fieldTitle      = $('#ins-car-title');
    this.$fieldEmail      = $('#ins-car-email');
    this.$fieldPhone      = $('#ins-car-phone');
    this.$fieldClaimNum   = $('#ins-car-claim-num');
    this.$fieldPolicyNum  = $('#ins-car-policy-num');
    this.$fieldMarketPerc = $('#ins-car-market-perc');
    this.$fieldAddr       = $('#ins-car-street-addr');
    this.$fieldCity       = $('#ins-car-city');
    this.$fieldState      = $('#ins-car-state');
    this.$fieldZip        = $('#ins-car-zip');
    this.$fieldCountry    = $('#ins-car-country');

    // event handler to add a location
    $("#add-carrier").click(function(){
        self.isEditingId = -1;
        insFormValidator.resetForm(); // reset so old errors don't carry over
        self.showModal();
    });

    // event handler to hide the modal
    $('#ins-carrier-modal .close').click(function(){

        // remove validation for file input
        $('#ins-carrier-modal input[type="file"]').rules( "remove" );

        // get current object ID for file field
        if (self.isEditingId == -1) {
            var fileFieldId = self.insCarriers.length + 1;
        }
        else {
            var fileFieldId = self.isEditingId + 1;
        }

        self.hideModal();
    });

    // event handler for when modal is submitted
    $('#submit-ins-carrier').click(function(){

        // validate the form before submitting
        $('#add-ins-carrier-form').validate();
        self.validatePhoneField();
        if(!$('#add-ins-carrier-form').valid()  || (!self.validatePhoneField()))
        {
            return;
        }

        $('#ins-carrier-modal input[type="file"]').rules( "remove" ); // remove validation rules associated with the file input

        self.submit(self.isEditingId);

        // if there are already 5 carriers, hide the add carrier button
        /*
        if (self.insCarriers.length >= 5)
        {
            $('#add-carrier').hide();
        }
        */

    });

    // We're binding this event onto the body, so any
    // loss locations created "in the future" will be handled
    // from this method. We're doing it here, rather than in the
    // Loss Location object so we have access to the this.lossLocations
    // array. -- This is a little janky, but oh well..
    $("#ins-carriers-wrap").on("click", ".remove-btn", function(e){
        e.preventDefault();
        self.remove(this);

        /*
        if (self.insCarriers.length < 5)
        {
            $('#add-carrier').show();
        }
        */
    });

    // edit buttons
    $('#ins-carriers-wrap').on("click", ".edit-btn", function(e){
        e.preventDefault();
        // get the ID of the loss location being edited
        var $el = $(this);
        var insCarrierId = Number($el.parents('.ins-carrier').data("ins-carrier-id"));
        self.isEditingId = insCarrierId;
        self.showModal(insCarrierId);
    });

    var insFormValidator = $('#add-ins-carrier-form').validate({
        rules: {
            "ins-car-carrier": {
                required: true
            },
            "ins-car-name": {
                required: true
            },
            "ins-car-email": {
                required: true,
                email: true
            },
            /*
            "ins-car-phone": {
                required: true
            },
            */
            /*
            "ins-car-claim-num": {
                required: true
            },
            */
            /*
            "ins-car-market-perc": {
                required: true
            },
            */
            "ins-car-street-addr": {
                required: true
            },
            "ins-car-city": {
                required: true
            },
            "ins-car-state": {
                required: true
            },
            "ins-car-zip": {
                required: true
            },
            "ins-car-country": {
                required: true
            }

        },
        errorPlacement: function(error, element) {
            if (element.attr("type") == "text") {
                error.appendTo( element.closest("div.field") );
            }
            else {
                error.appendTo( element.closest("div") );
            }
        }
    });

    this.$fieldPhone.on('blur', function() {
        self.validatePhoneField();
    });

    this.$fieldPhone.on('keyup', function() {
        self.validatePhoneField();
    });

    this.initGoogleAddressFields();

};

/**
 * Init'ing our Google Shipping Address Fields
 */
InsCarrierController.prototype.initGoogleAddressFields = function(){

    var self = this;

    // contact info address
    var $carrierAddressField = $("#ins-car-street-addr");

    var contactInfoGoogleAddressField = new GoogleAddressField({
        $addressField: $carrierAddressField,
        fields: {
            $address: $("#ins-car-street-addr"),
            $city: $("#ins-car-city"),
            $state: $("#ins-car-state"),
            $zipcode: $("#ins-car-zip"),
            $country: $("#ins-car-country")
        },
        callback: function(){

        }
    });

    contactInfoGoogleAddressField.init();

};

InsCarrierController.prototype.submit = function(insCarrierId){

     // get phone number
    var iti = window.intlTelInputGlobals.getInstance(this.$fieldPhone[0]);
    var phoneNumber = iti.getNumber();

    // get current object ID for file field
    if (insCarrierId == -1) {
        var fileFieldId = this.insCarriers.length; // don't add 1 - this item was just added to the array so length is correct
    }
    else {
        var fileFieldId = insCarrierId;
    }

    // add/edit the submitted information
    if (insCarrierId == -1)
    {
        this.add(
        	this.$fieldCarrier.val(),
		    this.$fieldName.val(),
		    this.$fieldTitle.val(),
		    this.$fieldEmail.val(),
		    phoneNumber,
		    this.$fieldClaimNum.val(),
            this.$fieldPolicyNum.val(),
		    this.$fieldMarketPerc.val(),
		    this.$fieldAddr.val(),
		    this.$fieldCity.val(),
		    this.$fieldState.val(),
		    this.$fieldZip.val(),
		    this.$fieldCountry.val()
        );
    }
    else
    {
        console.log('editing: ' + insCarrierId);
        this.updateLocation(
            insCarrierId,
            this.$fieldCarrier.val(),
		    this.$fieldName.val(),
		    this.$fieldTitle.val(),
		    this.$fieldEmail.val(),
		    phoneNumber,
		    this.$fieldClaimNum.val(),
            this.$fieldPolicyNum.val(),
		    this.$fieldMarketPerc.val(),
		    this.$fieldAddr.val(),
		    this.$fieldCity.val(),
		    this.$fieldState.val(),
		    this.$fieldZip.val(),
		    this.$fieldCountry.val()
        );
    }

    this.hideModal();
};

InsCarrierController.prototype.validatePhoneField = function(){

    var self = this;
    var iti = window.intlTelInputGlobals.getInstance(self.$fieldPhone[0]);
    var isValid = iti.isValidNumber();

    var errorMap = ["Invalid number.", "Invalid country code.", "Too short.", "Too long.", "Invalid number."];

    // remove any existing error messages from the field
    self.clearPhoneFieldErrors();

    if (!self.$fieldPhone.val().trim())
    {
        var returnMsg = "This field is required.";
    }
    else if (!isValid)
    {
        var errorCode = iti.getValidationError();
        var returnMsg = errorMap[errorCode];
    }
    else
    {
        return true;
    }

    // create our error label
    var $errorLabel = $('<label>').addClass('error-label').attr('for', self.$fieldPhone.attr('id')).attr('id', self.$fieldPhone.attr('id') + '-error').text(returnMsg);
    // add the error to the DOM
    self.$fieldPhone.closest('[data-form-field-phone]').append($errorLabel);

    return false;

};

InsCarrierController.prototype.clearPhoneFieldErrors = function(){

    this.$fieldPhone.closest('[data-form-field-phone]').find('label.error-label').remove();

};

InsCarrierController.prototype.showModal = function(insCarrierId = -1){

    // get current object ID for file field
    if (insCarrierId == -1) {
        var fileFieldId = this.insCarriers.length + 1;
    }
    else {
        var fileFieldId = insCarrierId + 1;
    }

    this.updateModalFields(insCarrierId);
    this.clearPhoneFieldErrors();

    // make file field required
    /*
    $('#ins-carrier-modal input[type="file"]').rules( "add", {
        required: true
    });
    */

    if (window.matchMedia("(max-width: 480px)").matches) {
      $('body').addClass('fixed-body'); // adding this class fixes a bug in iOS 11 safari
    }

    $('.modal-wrap').css('display', 'flex');
    this.$modal.show();
    this.$modal.fadeTo(10, 1);
    $('.modal-overlay').show();
    $('.modal-overlay').fadeTo(10, 1);

};

// this function updates the modal fields
// clears the fields for new carrier
// sets the field to saved values for edits
InsCarrierController.prototype.updateModalFields = function(insCarrierId){

    var self = this;

    var iti = window.intlTelInputGlobals.getInstance(self.$fieldPhone[0]);

    if (insCarrierId == -1)
    {
        // adding new location, clear fields
        $('#ins-carrier-modal').find('input').val('');
        // reset p tag that displays attached documents
        $('#ins-car-documents').text('No documents selected');

        // clear phone field and set country back to default
        this.$fieldPhone.val('');
        iti.setCountry('us');
    }
    else
    {
        // editing location, fill in fields
        var insCarrier = this.insCarriers[insCarrierId];

        this.$fieldCarrier.val(insCarrier.getCarrier());
	    this.$fieldName.val(insCarrier.getContactName());
	    this.$fieldTitle.val(insCarrier.getContactTitle());
	    this.$fieldEmail.val(insCarrier.getEmail());
	    //this.$fieldPhone.val(insCarrier.getPhone());
	    this.$fieldClaimNum.val(insCarrier.getClaimNum());
        this.$fieldPolicyNum.val(insCarrier.getPolicyNum());
	    this.$fieldMarketPerc.val(insCarrier.getMarketPerc());
	    this.$fieldAddr.val(insCarrier.getAddress());
	    this.$fieldCity.val(insCarrier.getCity());
	    this.$fieldState.val(insCarrier.getState());
	    this.$fieldZip.val(insCarrier.getZip());
	    this.$fieldCountry.val(insCarrier.getCountry());

        // phone field
        iti.setNumber(insCarrier.getPhone());

    }
};


InsCarrierController.prototype.hideModal = function(){

    $('body').removeClass('fixed-body');
    if (window.matchMedia("(max-width: 480px)").matches) {
        $(window).scrollTop( $('#ind-adj-section').offset().top ); // scroll back, because adding fixed scrolls to top
    }

    this.$modal.hide();
    $('.modal-wrap').css('display', 'none');
    this.$modal.css('opacity', '0');
    $('.modal-overlay').hide();
    $('.modal-overlay').css('opacity', '0');

};

// where we create individual Carriers, and add them
// into the insCarriers array
InsCarrierController.prototype.add = function(carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country){

    var insCarrier = new InsCarrier(carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country);
    insCarrier.addToDOM();
    this.insCarriers.push(insCarrier);
    this.updateCarrierIds();
    this.updateCarrierFormFields();

};

// where we remove invidual carriers from the DOM
InsCarrierController.prototype.remove = function(el){

    var $el = $(el);
    var insCarrierId = Number($el.parents('.ins-carrier').data("ins-carrier-id"));
    this.insCarriers[insCarrierId].removeFromDOM();
    this.insCarriers.splice(insCarrierId, 1);

    this.updateCarrierIds();
    this.updateCarrierFormFields();

};

// this updates an existing carrier
InsCarrierController.prototype.updateLocation = function(insCarrierId, carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country){
    this.insCarriers[insCarrierId].update(carrier, contactName, contactTitle, email, phone, claimNum, policyNum, marketPerc, address, city, state, zip, country);
    this.updateCarrierIds();
    this.updateCarrierFormFields();
};

// after we add or remove from the DOM we need to update IDs
// to refect the new organization of the active arrays
InsCarrierController.prototype.updateCarrierIds = function(){

    $.each(this.insCarriers, function(index){

        var insCarrier = this;

        insCarrier.updateId(index);

    });

}

// this function updates the form fields associated with each carrier
InsCarrierController.prototype.updateCarrierFormFields = function(){
	// clear the fields
    /*
	$('.js-ins-carrier-field').val('');
    $.each(this.insCarriers, function(index){
        var insCarrier = this;
        insCarrier.updateFormFields(index);
    });
    */

    // get our insurance carrier input wrapper
    var $insCarriersFieldWrap = $('#ins-carriers-table-fields-wrapper');

    // clear our insurance carrier form fields out
    $insCarriersFieldWrap.empty();

    // go through this.insCarriers and add table inputs for each location
    $.each(this.insCarriers, function(index){

        var insCarrier = this;
        var insCarrierFieldId = index + 1; // form fields are 1-indexed

        // insurance carrier
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insuranceCarrier]')
            .val(insCarrier.carrier)
            .appendTo($insCarriersFieldWrap);

        // contact name
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][contactName]')
            .val(insCarrier.contactName)
            .appendTo($insCarriersFieldWrap);

        // contact title
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][titleOfContact]')
            .val(insCarrier.contactTitle)
            .appendTo($insCarriersFieldWrap);

        // email
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][email]')
            .val(insCarrier.email)
            .appendTo($insCarriersFieldWrap);

        // phone
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][phone]')
            .val(insCarrier.phone)
            .appendTo($insCarriersFieldWrap);

        // claim number
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][claimNumber]')
            .val(insCarrier.claimNum)
            .appendTo($insCarriersFieldWrap);

        // policy number
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][policyNumber]')
            .val(insCarrier.policyNum)
            .appendTo($insCarriersFieldWrap);

        // market %
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][market]')
            .val(insCarrier.marketPerc)
            .appendTo($insCarriersFieldWrap);

        // insurer street address
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insurerStreetAddress]')
            .val(insCarrier.address)
            .appendTo($insCarriersFieldWrap);

        // insurer city
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insurerCity]')
            .val(insCarrier.city)
            .appendTo($insCarriersFieldWrap);

        // insurer state
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insurerState]')
            .val(insCarrier.state)
            .appendTo($insCarriersFieldWrap);

        // insurer zip
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insurerZip]')
            .val(insCarrier.zip)
            .appendTo($insCarriersFieldWrap);

        // insurer country
        $('<input type="text" />')
            .attr('name', 'fields[insuranceCarriers][' + insCarrierFieldId +'][insurerCountry]')
            .val(insCarrier.country)
            .appendTo($insCarriersFieldWrap);

    });

};

export default  InsCarrierController;
